<template>
  <div id="app" class="app-container">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="navbar-logo">
          <h2>麦田熊<span>餐饮SaaS</span></h2>
        </div>
        <div class="navbar-menu">
          <ul>
            <li><a href="#product">产品介绍</a></li>
            <li><a href="#features">核心功能</a></li>
            <li><a href="#cases">客户案例</a></li>
          </ul>
        </div>
        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <!-- 移动端菜单 -->
      <div class="mobile-menu" v-show="showMobileMenu">
        <ul>
          <li><a href="#product" @click="toggleMobileMenu">产品介绍</a></li>
          <li><a href="#features" @click="toggleMobileMenu">核心功能</a></li>
          <li><a href="#cases" @click="toggleMobileMenu">客户案例</a></li>
        </ul>
      </div>
    </nav>

    <!-- 英雄区（品牌核心展示） -->
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>麦田熊 · 让餐饮经营<br />像麦田丰收一样简单</h1>
          <p>
            专为餐饮企业打造的轻量化 餐饮SaaS
            系统，覆盖点餐、收银、库存、营销全场景，降本增效，增收提利
          </p>
        </div>
        <div class="hero-image">
          <img src="@/assets/pic1.png" alt="麦田熊餐饮SaaS系统演示" />
        </div>
      </div>
    </section>

    <!-- 产品介绍 -->
    <section id="product" class="product">
      <div class="container">
        <div class="section-title">
          <h2>麦田熊核心产品</h2>
          <p>轻量化、易上手、高适配的餐饮管理解决方案</p>
        </div>
        <div class="product-cards">
          <div class="product-card">
            <div class="card-icon">📱</div>
            <h3>智能收银</h3>
            <p>
              多支付方式、实时对账、简易操作，适配小吃店、快餐店、正餐店等多种场景
            </p>
          </div>
          <div class="product-card">
            <div class="card-icon">🍽️</div>
            <h3>全渠道点单</h3>
            <p>扫码点单、小程序点单、外卖对接，减少人工，提升翻台率</p>
          </div>
          <div class="product-card">
            <div class="card-icon">📊</div>
            <h3>数据管家</h3>
            <p>营业数据、菜品分析、用户画像，用数据驱动经营决策</p>
          </div>
          <div class="product-card">
            <div class="card-icon">👥</div>
            <h3>私域运营</h3>
            <p>积分、储值、优惠券，低成本沉淀客户，提升复购率</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心功能 -->
    <section id="features" class="features">
      <div class="container">
        <div class="section-title">
          <h2>核心功能</h2>
          <p>小而精，解决餐饮经营的核心痛点</p>
        </div>
        <div class="features-list">
          <div class="feature-item">
            <div class="feature-image">
              <img src="@/assets/pic2.png" alt="库存管理" />
            </div>
            <div class="feature-content">
              <h3>极简库存管理</h3>
              <p>
                专为餐饮设计的轻量化库存功能，无需专业财务，扫码盘点、食材预警、自动生成采购建议，减少浪费。
              </p>
              <ul>
                <li>食材效期提醒</li>
                <li>一键盘点库存</li>
                <li>采购单自动生成</li>
                <li>成本自动核算</li>
              </ul>
            </div>
          </div>
          <div class="feature-item reverse">
            <div class="feature-image">
              <img src="@/assets/pic3.png" alt="营销工具" />
            </div>
            <div class="feature-content">
              <h3>傻瓜式营销工具</h3>
              <p>
                无需专业运营，一键发布优惠券、拼团、秒杀活动，自动触达老客户，低成本拉新。
              </p>
              <ul>
                <li>模板化活动创建</li>
                <li>客户精准推送</li>
                <li>活动效果统计</li>
                <li>节日营销提醒</li>
              </ul>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-image">
              <img src="@/assets/pic4.png" alt="多端同步" />
            </div>
            <div class="feature-content">
              <h3>多端数据同步</h3>
              <p>
                手机、收银机多端数据实时同步，老板出门也能掌控门店经营情况。
              </p>
              <ul>
                <li>实时营业数据</li>
                <li>远程查看账单</li>
                <li>多门店统一管理</li>
                <li>员工权限分级</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户案例 -->
    <section id="cases" class="cases">
      <div class="container">
        <div class="section-title">
          <h2>客户案例</h2>
        </div>
        <div class="cases-slider">
          <div
            class="case-item"
            v-for="(caseItem, index) in caseList"
            :key="index"
          >
            <img :src="caseItem.image" :alt="caseItem.name" />
            <div class="case-info">
              <h3>{{ caseItem.name }}</h3>
              <p>{{ caseItem.desc }}</p>
              <div class="case-result">
                <span>{{ caseItem.result }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-top">
          <div class="footer-logo">
            <h2>麦田熊<span>餐饮SaaS</span></h2>
            <p>让餐饮经营更轻松</p>
          </div>
          <div class="footer-links">
            <div class="link-group">
              <h4>产品中心</h4>
              <ul>
                <a href="#">智能收银</a>
                <a href="#">点餐系统</a>
                <a href="#">数据管家</a>
                <a href="#">会员运营</a>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2026 杭州麦田熊科技有限公司 版权所有 | 浙ICP备2026012517号-1</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      // 移动端菜单控制
      showMobileMenu: false,

      // 客户案例数据（贴合餐饮场景）
      caseList: [
        {
          image: "https://twokuaizi.com/img/logo.5ad52dc3.jpg",
          name: "喜铺破包子",
          desc: "全国600+门店，使用我司SaaS系统实现扫码点单+库存统一管理",
          result: "",
        },
      ],
    };
  },
  methods: {
    // 切换移动端菜单
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
  },
};
</script>

<style scoped>
/* 全局基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.app-container {
  min-height: 100vh;
  background-color: #f9f9f9;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 按钮样式（麦田熊品牌色：麦黄+科技蓝） */
.btn-primary {
  display: inline-block;
  background: #e6a628; /* 麦黄色主色 */
  color: white;
  padding: 12px 24px;
  border-radius: 6px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.btn-primary:hover {
  background: #d19518; /* 深麦黄 */
}

.btn-secondary {
  display: inline-block;
  background: white;
  color: #e6a628;
  padding: 11px 23px;
  border-radius: 6px;
  text-decoration: none;
  border: 1px solid #e6a628;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
  margin-left: 15px;
}

.btn-secondary:hover {
  background: #fff9e8; /* 浅麦黄背景 */
}

/* 标题样式 */
.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 32px;
  color: #333;
  margin-bottom: 12px;
  position: relative;
  display: inline-block;
}

.section-title h2::after {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #6dae4f; /* 麦田绿 */
  border-radius: 3px;
}

.section-title p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 导航栏样式 */
.navbar {
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.navbar-logo h2 {
  color: #333;
  font-size: 22px;
}

.navbar-logo h2 span {
  color: #e6a628;
  font-weight: normal;
  margin-left: 5px;
}

.navbar-menu ul {
  display: flex;
  list-style: none;
}

.navbar-menu li {
  margin-left: 30px;
}

.navbar-menu a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  transition: color 0.3s;
}

.navbar-menu a:hover {
  color: #e6a628;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 22px;
  cursor: pointer;
}

.mobile-menu-btn span {
  width: 100%;
  height: 3px;
  background: #333;
  border-radius: 3px;
}

/* 移动端菜单 */
.mobile-menu {
  display: none;
  background: white;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.mobile-menu ul {
  list-style: none;
}

.mobile-menu li {
  margin-bottom: 15px;
}

.mobile-menu a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
}

/* 英雄区样式 */
.hero {
  padding: 120px 0 80px;
  background: linear-gradient(135deg, #fff9e8 0%, #f8f0d7 100%);
  margin-top: 70px;
}

.hero .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.hero-content {
  flex: 1;
  min-width: 300px;
  margin-right: 40px;
}

.hero-content h1 {
  font-size: 40px;
  color: #333;
  line-height: 1.4;
  margin-bottom: 20px;
}

.hero-content h1 br {
  display: none;
}

.hero-content p {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 500px;
}

.hero-image {
  flex: 1;
  min-width: 300px;
  margin-top: 30px;
}

.hero-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

/* 产品介绍样式 */
.product {
  padding: 80px 0;
  background: white;
}

.product-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.product-card {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.card-icon {
  font-size: 40px;
  margin-bottom: 20px;
  color: #e6a628;
}

.product-card h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
}

.product-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 核心功能样式 */
.features {
  padding: 80px 0;
  background: #f9f9f9;
}

.features-list {
  margin-top: 20px;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 60px;
  flex-wrap: wrap;
}

.feature-item.reverse {
  flex-direction: row-reverse;
}

.feature-image {
  flex: 1;
  min-width: 300px;
  padding: 0 20px;
}

.feature-image img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.feature-content {
  flex: 1;
  min-width: 300px;
  padding: 0 20px;
}

.feature-content h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
}

.feature-content p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.feature-content ul {
  list-style: none;
}

.feature-content li {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.feature-content li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #6dae4f;
  font-weight: bold;
}

/* 客户案例样式 */
.cases {
  padding: 80px 0;
  background: white;
}

.cases-slider {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.case-item {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.3s;
}

.case-item:hover {
  transform: translateY(-5px);
}

.case-item img {
  width: 30%;
  height: 200px;
  object-fit: cover;
}

.case-info {
  padding: 20px;
}

.case-info h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.case-info p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.case-result {
  display: inline-block;
  background: #fff9e8;
  color: #e6a628;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
}

/* 价格方案样式 */
.pricing {
  padding: 80px 0;
  background: #f9f9f9;
}

.pricing-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.pricing-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 30px;
  position: relative;
  transition: transform 0.3s;
}

.pricing-card:hover {
  transform: translateY(-5px);
}

.pricing-card.recommended {
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.plan-tag {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: #6dae4f;
  color: white;
  padding: 5px 20px;
  border-radius: 20px;
  font-size: 14px;
}

.pricing-card h3 {
  font-size: 22px;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 10px;
}

.price {
  text-align: center;
  margin-bottom: 20px;
}

.currency {
  font-size: 20px;
  color: #e6a628;
  vertical-align: super;
}

.amount {
  font-size: 36px;
  color: #e6a628;
  font-weight: bold;
}

.period {
  font-size: 16px;
  color: #666;
  margin-left: 5px;
}

.plan-features {
  list-style: none;
  margin-bottom: 30px;
}

.plan-features li {
  font-size: 14px;
  color: #666;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  padding-left: 20px;
  position: relative;
}

.plan-features li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #6dae4f;
}

.plan-btn {
  display: block;
  text-align: center;
  width: 100%;
}

/* 联系我们样式 */
.contact {
  padding: 80px 0;
  background: white;
}

.contact-content {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
}

.contact-form {
  flex: 1;
  min-width: 300px;
  background: #f9f9f9;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  color: #333;
  outline: none;
  transition: border 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #e6a628;
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.contact-info {
  flex: 1;
  min-width: 300px;
}

.info-item {
  margin-bottom: 30px;
}

.info-item h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.info-item p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 免费试用样式 */
.demo {
  padding: 60px 0;
  background: linear-gradient(135deg, #e6a628 0%, #d19518 100%);
  text-align: center;
  color: white;
}

.demo-content h2 {
  font-size: 32px;
  margin-bottom: 15px;
}

.demo-content p {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.9;
}

.demo-form {
  display: flex;
  max-width: 500px;
  margin: 0 auto;
}

.demo-form input {
  flex: 1;
  padding: 14px 20px;
  border: none;
  border-radius: 6px 0 0 6px;
  font-size: 16px;
  outline: none;
}

.demo-form button {
  border-radius: 0 6px 6px 0;
  background: #333;
}

.demo-form button:hover {
  background: #222;
}

/* 页脚样式 */
.footer {
  background: #333;
  color: #ccc;
  padding: 60px 0 20px;
}

.footer-top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 40px;
}

.footer-logo {
  flex: 1;
  min-width: 250px;
  margin-bottom: 30px;
}

.footer-logo h2 {
  color: white;
  font-size: 22px;
  margin-bottom: 10px;
}

.footer-logo h2 span {
  color: #e6a628;
  font-weight: normal;
  margin-left: 5px;
}

.footer-logo p {
  color: #999;
  font-size: 14px;
}

.footer-links {
  flex: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
}

.link-group {
  min-width: 150px;
}

.link-group h4 {
  color: white;
  font-size: 16px;
  margin-bottom: 15px;
}

.link-group ul {
  list-style: none;
  margin-bottom: 10px;
}

.link-group a {
  color: #999;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  margin-right: 30px;
}

.link-group a:hover {
  color: #e6a628;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #444;
  font-size: 14px;
  color: #999;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .navbar-menu {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-menu {
    display: block;
  }

  .hero-content h1 {
    font-size: 32px;
  }

  .hero-content h1 br {
    display: block;
  }

  .feature-item {
    flex-direction: column;
  }

  .feature-item.reverse {
    flex-direction: column;
  }

  .feature-content {
    margin-top: 20px;
  }

  .pricing-card.recommended {
    transform: scale(1);
  }

  .demo-form {
    flex-direction: column;
  }

  .demo-form input {
    border-radius: 6px 6px 0 0;
    margin-bottom: 10px;
  }

  .demo-form button {
    border-radius: 0 0 6px 6px;
  }
}
</style>
